export enum DMSV3_CUSTOM_QUERIES_STORAGE_KEYS {
  LocationPreference = "dmsv3-custom-queries-location-preference"
}
